<template>
    <div>
        <div class="hint block mb10">
            <p class="font-red">提示：系统会自动根据相同合同，同业务单元拆分多个验收单！</p>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">验收单标题</label>
                </div>
                <div class="form-value">
                    <el-input class="width-2x" type="text" v-model="title"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default{
        name: 'swb-purch-receipt-save-confirm',
        desc: '购置验收保存确认框',
        data: function () {
            return {
                title: null
            }
        },
        created: function () {
        },
        methods: {
            // 返回数据
            getDlgResult: function () {
                if(Utils.isNoB(this.title)) {
                    MsgBox.warning("请输入验收单标题");
                    return;
                }
                //
                let result = {};
                result.type = 'info';
                result.data = this.title;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptSaveConfirm.vue